import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Pages.css';
import { ROUTES } from '../routes';

const buniLogo = `${process.env.PUBLIC_URL}/assest/img/buni logo.png`;

const mediaSections = [
  {
    path: ROUTES.pressConference,
    title: 'UNVEIL Press Conference',
    category: 'Press Releases',
    description:
      'Browse press releases and publications from the UNVEIL Press Conference.',
    documentCount: 4
  }
];

function MediaRelations() {
  const navigate = useNavigate();

  return (
    <div className="framework-page">
      <section className="framework-hero-compact">
        <div className="framework-hero-container">
          <h1 className="framework-hero-title">Media Relation</h1>
          <p className="framework-hero-subtitle">
            Access press releases, publications, and media resources from Buni Hub
          </p>
        </div>
      </section>

      <section className="framework-content-compact">
        <div className="framework-container">
          <div className="media-relations-grid">
            {mediaSections.map((section) => (
              <button
                key={section.path}
                type="button"
                className="media-relation-card"
                onClick={() => navigate(section.path)}
              >
                <div className="media-relation-card-icon">
                  <img src={buniLogo} alt="Buni logo" className="media-relation-card-logo" />
                </div>
                <div className="media-relation-card-body">
                  <span className="media-relation-card-category">{section.category}</span>
                  <h3 className="media-relation-card-title">{section.title}</h3>
                  <p className="media-relation-card-description">{section.description}</p>
                  <span className="media-relation-card-meta">
                    {section.documentCount} documents
                  </span>
                </div>
                <span className="media-relation-card-action">
                  Open
                  <i className="fas fa-arrow-right"></i>
                </span>
              </button>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default MediaRelations;
